<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="11">
        <strong>Management {{name}} : <span class="text-danger">Block is only possible when firewall mode is On(Block)</span></strong>
        <hr>
        <p>In one row, enter one {{name}}.</p>
        <p v-if="name == 'path'">Enter if there is an administrator path that needs to be protected.</p>
        <p>* Example</p>
        <pre v-html="ex"></pre>
        <!-- ex : /admin,/admin,/admin -->
      </b-col>
      <b-col sm="1">
        <div class="pull-right">
          <b-button size="sm" variant="outline-info" @click="explain"><i class="fa fa-question"></i></b-button>
        </div>
      </b-col>
    </b-row>
    <hr>
    <b-row>
      <b-col>
        <b-form-group>
          <b-form-textarea @update="update($event, name)" id="ph_content" v-model="model" :max-rows="50"></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <!-- 설명 모달 영역 -->
    <b-modal title="Path Block"  class="modal-info" v-model="explain_path" ok-variant="success" header-bg-variant="warning">
      <p>Block pages from specific paths.</p>
      <p>ex ) http://f1security.co.kr/manager/index.html</p>
      <p>Blocking the path /manager that looks like above will block index.html pages.</p>
    </b-modal>
    <b-modal title="Parameter Block"  class="modal-info" v-model="explain_params" ok-only no-close-on-backdrop ok-variant="success" header-bg-variant="warning">
      <p>Block certain parameters.</p>
      <p>ex ) kyword=password</p>
      <p>Blocking the password parameter that looks like above will detect/block the parameter of the word password.</p>
    </b-modal>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
